module.exports = __webpack_public_path__ + "static/media/b1.06657320.jpg";